<template v-slot>
  <div class="grid my-2">
    <div>
      <p class="font-normal text-sm leading-6 text-gray-900 m-0 px-2 py-2">Aanhef*</p>
      <div class="flex px-2 py-2">
        <input
          id="genderMale"
          name="prescriberGender"
          type="radio"
          :checked="details.gender === '1'"
          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-pdsPrimaryColor"
          @change="checkRadioAddress('1')"
        />
        <label for="genderMale" class="ml-3 block text-sm font-medium leading-6 text-gray-900"> Dhr. </label>
        <input
          id="genderFemale"
          name="prescriberGender"
          type="radio"
          class="h-4 w-4 border-gray-300 text-pdsPrimaryColor ml-4 focus:pdsPrimaryColor"
          :checked="details.gender === '2'"
          @change="checkRadioAddress('2')"
        />
        <label for="genderFemale" class="ml-3 block text-sm font-medium leading-6 text-gray-900"> Mevr. </label>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-4 px-2 py-2">
      <div class="w-1/2 sm:w-1/2 font-normal text-sm leading-6 text-gray-700">
        <input-groups
          id="Voorletters"
          v-model="details.initials"
          label="Voorletters*"
          :rules="{ required: true }"
          @input="updatePersonalDetails('initials', $event)"
        />
      </div>
      <div class="w-full sm:w-1/2 font-normal text-sm leading-6 text-gray-700">
        <input-groups
          id="Voornaam"
          v-model="details.firstName"
          label="Voornaam"
          @input="updatePersonalDetails('firstName', $event)"
        />
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-4 px-2 py-2">
      <div class="w-1/2 sm:w-1/2">
        <label class="font-normal text-sm leading-6 text-gray-700">Tussenvoegsel</label>
        <combo-boxes
          placeholder="Selecteren Tussenvoegsel"
          v-model="selectedPrepostionstion"
          @blur="updatePrepostion($event)"
          :list="prePositionsData"
        >
        </combo-boxes>
      </div>
      <div class="w-full sm:w-1/2 font-normal text-sm leading-6 text-gray-700">
        <input-groups
          id="Achternaam"
          v-model="details.lastName"
          label="Achternaam*"
          :rules="{ required: true }"
          @input="updatePersonalDetails('lastName', $event)"
        />
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-4 px-2 py-2">
      <div class="w-1/2 sm:w-1/2 font-normal text-sm leading-6 text-gray-800">
        <input-groups
          id="Telefoonnummer"
          v-model="details.mobileNumber"
          label="Telefoonnummer"
          :rules="{ regex: /^0\d{9}$/ }"
          @input="updatePersonalDetails('phoneNumber', $event)"
        />
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-4 px-2 py-2">
      <div class="w-1/2 sm:w-1/2 font-normal text-sm leading-6 text-gray-700">
        <input-groups
          id="Geboortedatum"
          v-model="details.dateOfBirth"
          label="Geboortedatum"
          placeholder="dd-mm-jjjj"
          :rules="{ required: false, regex: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/ }"
          @input="updatePersonalDetails('dateOfBirth', $event)"
        />
      </div>
    </div>
    <div class="flex flex-col sm:flex-row gap-4 px-2 py-2">
      <div class="w-1/2 sm:w-1/2 font-normal text-sm leading-6 text-gray-700">
        <input-groups
          id="prescriberemail"
          v-model="details.email"
          type="text"
          label="Persoonlijke e-mailadres*"
          :rules="{ required: true, isEmail: true }"
          @input="updatePersonalDetails('email', $event)"
          :errorWrapper="false"
        />
      </div>
    </div>
    <div v-if="showUserEmailExistAlert" class="text-sm text-red-600 px-2">
      <span
        >*Er is al een account geregistreerd met dit e-mailadres. Registreer met een ander e-mailadres of neem
        <a
          href="https://mediq.nl/contact/zorgprofessional"
          target="_blank"
          class="cursor-pointer font-semibold underline decoration-2 underline-offset-4 mt-1"
          ><u>contact op</u></a
        >
        om toegang tot dit account te krijgen.</span
      >
    </div>
    <div class="flex flex-col sm:flex-row px-2 py-2">
      <span class="text-black">
        <input type="checkbox" class="font-normal text-sm leading-6" v-model="details.newsletterSubscription" />
        Ik wil op de hoogte blijven van alle relevante informatie en hulpmiddelen die Mediq aanbiedt
      </span>
    </div>

    <!-- Buttons -->
    <div class="flex-col sm:flex-row justify-end gap-4">
      <button
        type="button"
        :class="{
          'text-white bg-pdsPrimaryColor cursor-pointer border-pdsPrimaryColor': !disableSaveButton,
          'text-white bg-gray-300 border-gray-300 cursor-not-allowed': disableSaveButton
        }"
        @click="savePerscriberDetails()"
        class="text-center rounded-full border w-32 h-10"
      >
        Doorgaan
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { useForm } from 'vee-validate';
import { computed } from 'vue';

export default {
  name: 'AccountRegistrationPrescriberDetail',
  components: {},
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  emits: ['setPrescriberDetails'],
  setup(props, { emit }) {
    const { validate } = useForm();
    const selectedPrepostionstion = ref({ id: '', data: '' });
    const prePositionsData = ref([]);
    const showUserEmailExistAlert = ref(false);
    const emailChanged = ref(false);
    let isInitialRun = true;
    const disableSaveButton = ref(true);
    const checkRadioAddress = (value) => {
      props.details.gender = value;
    };
    const setPrescriberDetails = () => {
      emit('setPrescriberDetails', props.details);
    };
    const getPrePositionsData = async () => {
      return await axios.get('Registration/GetPrePositions').then((response) => {
        prePositionsData.value.push({ id: 0, data: 'Selecteren Tussenvoegsel' });
        response.data.map((acc, item) => {
          prePositionsData.value.push({ id: acc.prePositionCode, data: acc.prePosition });
        });
        if (props.details && props.details.prePositionCode) {
          let existingItem = prePositionsData.value.find((item) => item.id === props.details.prePositionCode);
          if (existingItem) {
            selectedPrepostionstion.value.id = existingItem.id;
            selectedPrepostionstion.value.data = existingItem.data;
          }
        }
      });
    };
    const updatePersonalDetails = (key, event) => {
      props.details[key] = event.target.value;
      isFormValid();
    };
    const savePerscriberDetails = async () => {
      const result = await validate();
      if (result.valid) {
        axios.get('Registration/IsUserEmailAlreadyExists?email=' + props.details.email).then((response) => {
          if (response.data.data == false) {
            setPrescriberDetails();
            showUserEmailExistAlert.value = false;
          } else {
            showUserEmailExistAlert.value = true;
          }
        });
      }
    };
    const updatePrepostion = async (event) => {
      if (selectedPrepostionstion.value.id === 0) {
        props.details.prePositionCode = null;
        props.details.prePosition = null;
      } else {
        props.details.prePositionCode = selectedPrepostionstion.value.id;
        props.details.prePosition = selectedPrepostionstion.value.data;
      }
    };

    const isFormValid = async () => {
      const result = await validate();
      if (result.valid) {
        disableSaveButton.value = false;
      } else {
        disableSaveButton.value = true;
      }
    };
    watch(
      () => props.details?.email,
      (newVal, oldVal) => {
        if (isInitialRun) {
          isInitialRun = false;
          return;
        }
        if (newVal !== oldVal) {
          showUserEmailExistAlert.value = false;
          emailChanged.value = true;
        } else {
          emailChanged.value = false;
        }
      }
    );
    onMounted(() => {
      getPrePositionsData();
      if (props.details && props.details.email && props.details.lastName && props.details.initials) {
        disableSaveButton.value = false;
      }
    });
    return {
      updatePersonalDetails,
      savePerscriberDetails,
      checkRadioAddress,
      getPrePositionsData,
      prePositionsData,
      selectedPrepostionstion,
      setPrescriberDetails,
      updatePrepostion,
      showUserEmailExistAlert,
      disableSaveButton
    };
  }
};
</script>
